export function subscribeToNewsletter(
  baseUrl: string,
  queryParams = {},
  payload = {}
) {
  const url = new URL(baseUrl);

  url.search = new URLSearchParams(queryParams).toString();

  return fetch(url, {
    method: "post",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).then((response) => response.text());
}
